import axiosInstance from "./axiosInstance";
import Cookies from 'js-cookie';

async function refreshAccessToken() {

    try {
    axiosInstance.defaults.withCredentials = true;

    const response = await axiosInstance.post('/users/refresh')
    const newToken = response.data.token;
    Cookies.set("authToken", newToken, {expires: 7});
    return newToken;
    } catch (err) {
        return null;
    }
}
    
  

export default refreshAccessToken;